// BMI + TDEE (Katch-McArdle) helpers — shared by admin and client views.

export const ACTIVITY_OPTIONS = [
  { key: "sedentary", label: "Sedentario", hint: "poco o nessun esercizio", factor: 1.2 },
  { key: "light", label: "Leggero", hint: "1–3 allenamenti/settimana", factor: 1.375 },
  { key: "moderate", label: "Moderato", hint: "3–5 allenamenti/settimana", factor: 1.55 },
  { key: "active", label: "Attivo", hint: "6–7 allenamenti/settimana", factor: 1.725 },
  { key: "very_active", label: "Molto attivo", hint: "2× al giorno / lavoro fisico", factor: 1.9 },
];

export const activityFactor = (key) =>
  ACTIVITY_OPTIONS.find((o) => o.key === key)?.factor || null;

export const activityLabel = (key) =>
  ACTIVITY_OPTIONS.find((o) => o.key === key)?.label || null;

// BMI classification (WHO adult ranges).
export function bmiCategory(bmi) {
  if (!bmi || !isFinite(bmi)) return null;
  if (bmi < 18.5) return { key: "under", label: "Sottopeso", color: "#4A6274" };
  if (bmi < 25) return { key: "normal", label: "Normopeso", color: "#63705B" };
  if (bmi < 30) return { key: "over", label: "Sovrappeso", color: "#B08C4D" };
  return { key: "obese", label: "Obesità", color: "#A65D47" };
}

/**
 * @param {object} p
 * @param {number|null} p.pesoKg      latest weight (kg)
 * @param {number|null} p.heightCm    client height (cm)
 * @param {number|null} p.massaMagraKg latest lean mass (kg)
 * @param {string|null} p.activityLevel sedentary|light|moderate|active|very_active
 * @returns {{bmi:number|null, bmr:number|null, tdee:number|null, factor:number|null}}
 */
export function computeBmiTdee({ pesoKg, heightCm, massaMagraKg, activityLevel }) {
  const w = Number(pesoKg) || 0;
  const h = Number(heightCm) || 0;
  const mm = Number(massaMagraKg) || 0;
  const bmi = w > 0 && h > 0 ? +(w / Math.pow(h / 100, 2)).toFixed(1) : null;
  // Katch-McArdle: BMR = 370 + 21.6 × LBM(kg)
  const bmr = mm > 0 ? Math.round(370 + 21.6 * mm) : null;
  const factor = activityFactor(activityLevel);
  const tdee = bmr && factor ? Math.round(bmr * factor) : null;
  return { bmi, bmr, tdee, factor };
}
